var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from "react"; // import CoverdashQuotes from "@coverdash/quotes"
// import "@coverdash/quotes/lib/cjs/styles.css"

function isDefined(value) {
  return value !== undefined && value !== "";
}

function encodeNullOrNonNullValue(value) {
  if (value === undefined) {
    return encodeURIComponent("");
  }

  if (value === null) {
    return encodeURIComponent("null");
  }

  return encodeURIComponent(value.toString());
}

function Main(_a) {
  var styles = _a.styles,
      env = _a.env,
      allowScroll = _a.allowScroll,
      isDemo = _a.isDemo,
      reset = _a.reset,
      applicationSubmissionId = _a.applicationSubmissionId,
      coverdashBackButton = _a.coverdashBackButton,
      hideChat = _a.hideChat,
      license = _a.license,
      autoResize = _a.autoResize,
      source = _a.source,
      prefilled = _a.prefilled,
      onApplicationCreated = _a.onApplicationCreated,
      onChangeBusiness = _a.onChangeBusiness,
      onApplicationSubmitted = _a.onApplicationSubmitted,
      onBoundPolicy = _a.onBoundPolicy,
      fakeQuote = _a.fakeQuote,
      hybrid = _a.hybrid,
      onRejectedFreeQuotes = _a.onRejectedFreeQuotes,
      showCobrandedPage = _a.showCobrandedPage;
  var srcUrl = "https://quotes.".concat(env === "production" ? "" : "staging.", "coverdash.com?");
  srcUrl += "&isDemo=".concat(isDemo ? "true" : "false");
  srcUrl += "&license=".concat(license);

  if (typeof reset === "undefined" || reset) {
    srcUrl += "&reset=true";
  }

  if (applicationSubmissionId) {
    // the URL param will remain as applicationId for now
    srcUrl += "&applicationId=".concat(applicationSubmissionId);
  }

  if (hideChat) {
    srcUrl += "&hideChat=true";
  }

  if (coverdashBackButton) {
    srcUrl += "&coverdashBackButton=true";
  }

  if (source) {
    srcUrl += "&source=".concat(source);
  }

  if (prefilled) {
    if (isDefined(prefilled.userEmail)) {
      srcUrl += "&prefilled_userEmail=".concat(encodeNullOrNonNullValue(prefilled.userEmail));
    }

    if (isDefined(prefilled.userFirstName)) {
      srcUrl += "&prefilled_userFirstName=".concat(encodeNullOrNonNullValue(prefilled.userFirstName));
    }

    if (isDefined(prefilled.userLastName)) {
      srcUrl += "&prefilled_userLastName=".concat(encodeNullOrNonNullValue(prefilled.userLastName));
    }

    if (isDefined(prefilled.userPhone)) {
      srcUrl += "&prefilled_userPhone=".concat(encodeNullOrNonNullValue(prefilled.userPhone));
    }

    if (isDefined(prefilled.businessId)) {
      srcUrl += "&prefilled_businessId=".concat(encodeNullOrNonNullValue(prefilled.businessId));
    }

    if (isDefined(prefilled.businessName)) {
      srcUrl += "&prefilled_businessName=".concat(encodeNullOrNonNullValue(prefilled.businessName));
    }

    if (isDefined(prefilled.legalEntityType)) {
      srcUrl += "&prefilled_legalEntityType=".concat(prefilled.legalEntityType);
    }

    if (isDefined(prefilled.businessClassificationId)) {
      srcUrl += "&prefilled_businessClassificationId=".concat(prefilled.businessClassificationId);
    }

    if (isDefined(prefilled.companyType)) {
      srcUrl += "&prefilled_companyType=".concat(prefilled.companyType);
    }

    if (isDefined(prefilled.policyType)) {
      srcUrl += "&prefilled_policyType=".concat(prefilled.policyType);
    }

    if (isDefined(prefilled.effectiveDate)) {
      srcUrl += "&prefilled_effectiveDate=".concat(encodeNullOrNonNullValue(prefilled.effectiveDate));
    }

    if (isDefined(prefilled.startupIndustryId)) {
      srcUrl += "&prefilled_startupIndustryId=".concat(encodeNullOrNonNullValue(prefilled.startupIndustryId));
    }

    if (isDefined(prefilled.locationAddress)) {
      srcUrl += "&prefilled_locationAddress=".concat(encodeNullOrNonNullValue(prefilled.locationAddress));
    }

    if (isDefined(prefilled.locationAddress2)) {
      srcUrl += "&prefilled_locationAddress2=".concat(encodeNullOrNonNullValue(prefilled.locationAddress2));
    }

    if (isDefined(prefilled.locationCity)) {
      srcUrl += "&prefilled_locationCity=".concat(encodeNullOrNonNullValue(prefilled.locationCity));
    }

    if (isDefined(prefilled.locationStateCode)) {
      srcUrl += "&prefilled_locationStateCode=".concat(encodeNullOrNonNullValue(prefilled.locationStateCode));
    }

    if (isDefined(prefilled.locationZip)) {
      srcUrl += "&prefilled_locationZip=".concat(encodeNullOrNonNullValue(prefilled.locationZip));
    }

    if (isDefined(prefilled.mailingAddressSameAsLocationAddress)) {
      srcUrl += "&prefilled_mailingAddressSameAsLocationAddress=".concat(encodeNullOrNonNullValue(prefilled.mailingAddressSameAsLocationAddress));
    }

    if (isDefined(prefilled.mailingAddress)) {
      srcUrl += "&prefilled_mailingAddress=".concat(encodeNullOrNonNullValue(prefilled.mailingAddress));
    }

    if (isDefined(prefilled.mailingAddress2)) {
      srcUrl += "&prefilled_mailingAddress2=".concat(encodeNullOrNonNullValue(prefilled.mailingAddress2));
    }

    if (isDefined(prefilled.mailingCity)) {
      srcUrl += "&prefilled_mailingCity=".concat(encodeNullOrNonNullValue(prefilled.mailingCity));
    }

    if (isDefined(prefilled.mailingStateCode)) {
      srcUrl += "&prefilled_mailingStateCode=".concat(encodeNullOrNonNullValue(prefilled.mailingStateCode));
    }

    if (isDefined(prefilled.mailingZip)) {
      srcUrl += "&prefilled_mailingZip=".concat(encodeNullOrNonNullValue(prefilled.mailingZip));
    }

    if (isDefined(prefilled.businessStartYear)) {
      srcUrl += "&prefilled_businessStartYear=".concat(encodeNullOrNonNullValue(prefilled.businessStartYear));
    }

    if (prefilled.yearsInBusiness !== null && typeof prefilled.yearsInBusiness !== "undefined") {
      srcUrl += "&prefilled_yearsInBusiness=".concat(encodeNullOrNonNullValue(prefilled.yearsInBusiness));
    }

    if (isDefined(prefilled.website)) {
      srcUrl += "&prefilled_website=".concat(encodeNullOrNonNullValue(prefilled.website));
    }

    if (prefilled.totalNumberOfEmployees !== null && typeof prefilled.totalNumberOfEmployees !== "undefined") {
      srcUrl += "&prefilled_totalNumberOfEmployees=".concat(encodeNullOrNonNullValue(prefilled.totalNumberOfEmployees));
    }

    if (prefilled.totalAnnualRevenue !== null && typeof prefilled.totalAnnualRevenue !== "undefined") {
      srcUrl += "&prefilled_totalAnnualRevenue=".concat(encodeNullOrNonNullValue(prefilled.totalAnnualRevenue));
    }

    if (prefilled.totalAnnualPayroll !== null && typeof prefilled.totalAnnualPayroll !== "undefined") {
      srcUrl += "&prefilled_totalAnnualPayroll=".concat(encodeNullOrNonNullValue(prefilled.totalAnnualPayroll));
    }

    if (isDefined(prefilled.ecommerceCategory)) {
      srcUrl += "&prefilled_ecommerceCategory=".concat(encodeNullOrNonNullValue(prefilled.ecommerceCategory));
    }

    if (isDefined(prefilled.sellingPlatforms)) {
      srcUrl += "&prefilled_sellingPlatforms=".concat(encodeNullOrNonNullValue(prefilled.sellingPlatforms));
    }

    if (isDefined(prefilled.manufactureOrRelabel)) {
      srcUrl += "&prefilled_manufactureOrRelabel=".concat(encodeNullOrNonNullValue(typeof prefilled.manufactureOrRelabel == "undefined" ? "" : prefilled.manufactureOrRelabel));
    }

    if (isDefined(prefilled.areProductsHandcrafted)) {
      srcUrl += "&prefilled_areProductsHandcrafted=".concat(encodeNullOrNonNullValue(typeof prefilled.areProductsHandcrafted == "undefined" ? "" : prefilled.areProductsHandcrafted));
    }

    if (isDefined(prefilled.annualManufacturedUnits)) {
      srcUrl += "&prefilled_annualManufacturedUnits=".concat(encodeNullOrNonNullValue(prefilled.annualManufacturedUnits));
    }

    if (isDefined(prefilled.importGoodsInternationally)) {
      srcUrl += "&prefilled_importGoodsInternationally=".concat(encodeNullOrNonNullValue(typeof prefilled.importGoodsInternationally == "undefined" ? "" : prefilled.importGoodsInternationally));
    }

    if (isDefined(prefilled.manufactureOrSellListedItems)) {
      srcUrl += "&prefilled_manufactureOrSellListedItems=".concat(encodeNullOrNonNullValue(typeof prefilled.manufactureOrSellListedItems == "undefined" ? "" : prefilled.manufactureOrSellListedItems));
    }

    if (isDefined(prefilled.previousLosses)) {
      srcUrl += "&prefilled_previousLosses=".concat(encodeNullOrNonNullValue(typeof prefilled.previousLosses == "undefined" ? "" : prefilled.previousLosses));
    }

    if (prefilled.previousLossAmount !== null && typeof prefilled.previousLossAmount !== "undefined") {
      srcUrl += "&prefilled_previousLossAmount=".concat(encodeNullOrNonNullValue(prefilled.previousLossAmount));
    }

    if (isDefined(prefilled.previousLossDescription)) {
      srcUrl += "&prefilled_previousLossDescription=".concat(encodeNullOrNonNullValue(prefilled.previousLossDescription));
    }

    if (isDefined(prefilled.policyCancelledOrNonRenewed)) {
      srcUrl += "&prefilled_policyCancelledOrNonRenewed=".concat(encodeNullOrNonNullValue(typeof prefilled.policyCancelledOrNonRenewed == "undefined" ? "" : prefilled.policyCancelledOrNonRenewed));
    }

    if (isDefined(prefilled.operatedWithoutInsuranceCoverage)) {
      srcUrl += "&prefilled_operatedWithoutInsuranceCoverage=".concat(encodeNullOrNonNullValue(typeof prefilled.operatedWithoutInsuranceCoverage == "undefined" ? "" : prefilled.operatedWithoutInsuranceCoverage));
    }

    if (isDefined(prefilled.purchasedBefore)) {
      srcUrl += "&prefilled_purchasedBefore=".concat(encodeNullOrNonNullValue(typeof prefilled.purchasedBefore == "undefined" ? "" : prefilled.purchasedBefore));
    }

    if (isDefined(prefilled.ownOrOperateOtherBusinessSameName)) {
      srcUrl += "&prefilled_ownOrOperateOtherBusinessSameName=".concat(encodeNullOrNonNullValue(typeof prefilled.ownOrOperateOtherBusinessSameName == "undefined" ? "" : prefilled.ownOrOperateOtherBusinessSameName));
    }

    if (isDefined(prefilled.filedForBankruptcy)) {
      srcUrl += "&prefilled_filedForBankruptcy=".concat(encodeNullOrNonNullValue(typeof prefilled.filedForBankruptcy == "undefined" ? "" : prefilled.filedForBankruptcy));
    }

    if (isDefined(prefilled.isSaasProvider)) {
      srcUrl += "&prefilled_isSaasProvider=".concat(encodeNullOrNonNullValue(typeof prefilled.isSaasProvider == "undefined" ? "" : prefilled.isSaasProvider));
    }

    if (isDefined(prefilled.buildingSprinklered)) {
      srcUrl += "&prefilled_buildingSprinklered=".concat(encodeNullOrNonNullValue(typeof prefilled.buildingSprinklered == "undefined" ? "" : prefilled.buildingSprinklered));
    }

    if (isDefined(prefilled.valueOfAssets)) {
      srcUrl += "&prefilled_valueOfAssets=".concat(encodeNullOrNonNullValue(prefilled.valueOfAssets));
    }

    if (isDefined(prefilled.buildingSquareFootage)) {
      srcUrl += "&prefilled_buildingSquareFootage=".concat(encodeNullOrNonNullValue(prefilled.buildingSquareFootage));
    }

    if (isDefined(prefilled.occupiedSquareFootage)) {
      srcUrl += "&prefilled_occupiedSquareFootage=".concat(encodeNullOrNonNullValue(prefilled.occupiedSquareFootage));
    }

    if (isDefined(prefilled.domainNames)) {
      srcUrl += "&prefilled_domainNames=".concat(encodeNullOrNonNullValue(prefilled.domainNames));
    }

    if (isDefined(prefilled.piiPhi)) {
      srcUrl += "&prefilled_piiPhi=".concat(encodeNullOrNonNullValue(prefilled.piiPhi));
    }

    if (isDefined(prefilled.piiPhiCount)) {
      srcUrl += "&prefilled_piiPhiCount=".concat(encodeNullOrNonNullValue(prefilled.piiPhiCount));
    }

    if (isDefined(prefilled.ccCustomerCount)) {
      srcUrl += "&prefilled_ccCustomerCount=".concat(encodeNullOrNonNullValue(prefilled.ccCustomerCount));
    }

    if (isDefined(prefilled.awareOfNewClaims)) {
      srcUrl += "&prefilled_awareOfNewClaims=".concat(encodeNullOrNonNullValue(prefilled.awareOfNewClaims));
    }

    if (isDefined(prefilled.awareOfNewClaimsExplanation)) {
      srcUrl += "&prefilled_awareOfNewClaimsExplanation=".concat(encodeNullOrNonNullValue(prefilled.awareOfNewClaimsExplanation));
    }

    if (isDefined(prefilled.numberOfClaims)) {
      srcUrl += "&prefilled_numberOfClaims=".concat(encodeNullOrNonNullValue(prefilled.numberOfClaims));
    }

    if (isDefined(prefilled.encryptsData)) {
      srcUrl += "&prefilled_encryptsData=".concat(encodeNullOrNonNullValue(prefilled.encryptsData));
    }

    if (isDefined(prefilled.hasTechEo)) {
      srcUrl += "&prefilled_hasTechEo=".concat(encodeNullOrNonNullValue(prefilled.hasTechEo));
    }

    if (isDefined(prefilled.hasEoMpl)) {
      srcUrl += "&prefilled_hasEoMpl=".concat(encodeNullOrNonNullValue(prefilled.hasEoMpl));
    }

    if (isDefined(prefilled.contentComplaints)) {
      srcUrl += "&prefilled_contentComplaints=".concat(encodeNullOrNonNullValue(prefilled.contentComplaints));
    }

    if (isDefined(prefilled.reviewsContent)) {
      srcUrl += "&prefilled_reviewsContent=".concat(encodeNullOrNonNullValue(prefilled.reviewsContent));
    }

    if (isDefined(prefilled.backupAndRestore)) {
      srcUrl += "&prefilled_backupAndRestore=".concat(encodeNullOrNonNullValue(prefilled.backupAndRestore));
    }

    if (isDefined(prefilled.dualControl)) {
      srcUrl += "&prefilled_dualControl=".concat(encodeNullOrNonNullValue(prefilled.dualControl));
    }

    if (isDefined(prefilled.useCloudStorage)) {
      srcUrl += "&prefilled_useCloudStorage=".concat(encodeNullOrNonNullValue(prefilled.useCloudStorage));
    }
  }

  if (fakeQuote) {
    srcUrl += "&fakeQuote=true";
  }

  if (hybrid) {
    srcUrl += "&hybrid=true";
  }

  if (showCobrandedPage) {
    srcUrl += "&showCobrandedPage=true";
  }

  var _b = React.useState(true),
      loading = _b[0],
      setLoading = _b[1];

  var _c = React.useState(""),
      createdApplicationId = _c[0],
      setCreatedApplicationId = _c[1];

  var onApplicationCreatedRef = React.useRef(onApplicationCreated);
  onApplicationCreatedRef.current = onApplicationCreated;
  React.useEffect(function () {
    if (createdApplicationId) {
      onApplicationCreatedRef.current && onApplicationCreatedRef.current(createdApplicationId);
    }
  }, [createdApplicationId, onApplicationCreatedRef]);

  var _d = React.useState(""),
      businessId = _d[0],
      setBusinessId = _d[1];

  var onChangeBusinessRef = React.useRef(onChangeBusiness);
  onChangeBusinessRef.current = onChangeBusiness;
  React.useEffect(function () {
    if (businessId) {
      onChangeBusinessRef.current && onChangeBusinessRef.current(businessId);
    }
  }, [businessId, onChangeBusinessRef]);

  var _e = React.useState(""),
      submittedApplicationId = _e[0],
      setSubmittedApplicationId = _e[1];

  var onApplicationSubmittedRef = React.useRef(onApplicationSubmitted);
  onApplicationSubmittedRef.current = onApplicationSubmitted;
  React.useEffect(function () {
    if (submittedApplicationId) {
      onApplicationSubmittedRef.current && onApplicationSubmittedRef.current(submittedApplicationId);
    }
  }, [submittedApplicationId, onApplicationSubmittedRef]);

  var _f = React.useState(false),
      bound = _f[0],
      setBound = _f[1];

  var onBoundPolicyRef = React.useRef(onBoundPolicy);
  onBoundPolicyRef.current = onBoundPolicy;
  React.useEffect(function () {
    if (bound) {
      onBoundPolicyRef.current && onBoundPolicyRef.current(bound);
    }
  }, [bound, onBoundPolicyRef]);

  var _g = React.useState(false),
      rejectedFreeQuotes = _g[0],
      setRejectedFreeQuotes = _g[1];

  var onRejectedFreeQuotesRef = React.useRef(onRejectedFreeQuotes);
  onRejectedFreeQuotesRef.current = onRejectedFreeQuotes;
  React.useEffect(function () {
    if (rejectedFreeQuotes) {
      onRejectedFreeQuotesRef.current && onRejectedFreeQuotesRef.current(rejectedFreeQuotes);
    }
  }, [rejectedFreeQuotes, onRejectedFreeQuotesRef]);
  React.useEffect(function () {
    var quotesIframe = document.getElementById("coverdash-quotes-component");

    function listener(e) {
      if (isNaN(e.data)) {
        try {
          var data = JSON.parse(e.data);

          if (data.createdApplicationId) {
            setCreatedApplicationId(data.createdApplicationId);
          } //
          else if (data.businessId) {
            setBusinessId(data.businessId);
          } //
          else if (data.submittedApplicationId) {
            setSubmittedApplicationId(data.submittedApplicationId);
          } //
          else if (data.bound) {
            setBound(data.bound);
          } //
          else if (data.rejectedFreeQuotes) {
            setRejectedFreeQuotes(data.rejectedFreeQuotes);
          }

          return;
        } catch (error) {
          return;
        }
      }

      if (autoResize) {
        // @ts-ignore=
        quotesIframe.style.height = e.data + "px";
      }
    }

    window.addEventListener("message", listener, false);
    return function () {
      return window.removeEventListener("message", listener, false);
    };
  }, []);
  var isBrowser = typeof window !== "undefined";
  return React.createElement("div", null, loading && React.createElement("div", {
    style: __assign({
      position: "relative",
      backgroundColor: "white",
      height: "46rem"
    }, styles)
  }, React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      right: 0,
      marginTop: "16rem",
      height: "15rem",
      maxWidth: "48rem",
      marginLeft: "auto",
      marginRight: "auto",
      textAlign: "center"
    }
  }, React.createElement("div", {
    className: "animate-pulse",
    style: {
      backgroundColor: "rgb(229 231 235 / 1)",
      height: "2.5rem",
      borderRadius: "0.375rem"
    }
  }), React.createElement("div", {
    className: "animate-pulse",
    style: {
      backgroundColor: "rgb(229 231 235 / 1)",
      borderRadius: "0.375rem",
      marginTop: "6rem",
      width: "11rem",
      height: "3.5rem",
      marginLeft: "auto",
      marginRight: "auto"
    }
  }), React.createElement("div", {
    style: {
      marginTop: "2.5rem"
    }
  }, React.createElement("p", {
    style: {
      fontSize: "0.875rem",
      lineHeight: "1.25rem"
    }
  }, "Provided by"), React.createElement("img", {
    style: {
      marginLeft: "auto",
      marginRight: "auto"
    },
    src: "https://iamyqpnnibrsxhgaflmh.supabase.co/storage/v1/object/public/images-public/png/coverdash_logo_new_light_transparent_shield.png",
    alt: "Coverdash logo",
    width: 140.6859,
    height: 24
  })))), React.createElement("div", {
    style: {
      display: loading ? "none" : "block"
    }
  }, React.createElement("iframe", {
    onLoad: function onLoad() {
      console.log("~ loaded coverdash quotes ~");
      setLoading(false);
    },
    title: "Coverdash Quotes",
    id: "coverdash-quotes-component",
    style: styles,
    src: srcUrl,
    width: "100%",
    height: "800",
    scrolling: allowScroll ? "yes" : "no",
    frameBorder: "0"
  })));
}

export default Main;